import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import {breakpoints} from '../../../utils/styles';
import SeatsScreen from './SeatsScreen';
import './SeatsSelection.css';

const Auditorium = styled.div`
    border-top: none;
    margin-top: 1em;
    max-width: 100%;
    padding: 4rem 2rem 1rem;
    position:relative;
    
    ${props => props.screenImage
      ? `
        background: none;
        padding-top: 8rem;
        `
      : `
        background-image:-webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(0,0,0,0.25)), color-stop(15%, rgba(255,255,255,0)));
        background-image:linear-gradient(to bottom, rgba(0,0,0,0.25) 0, rgba(255,255,255,0) 15%);
        border-radius: 30% 30% 0 0 / 10% 10% 0 0
        &:before {
            border-radius: 30% 30% 0 0 / 10% 10% 0 0
            border-top: 5px solid rgba(208,3,61,0.5);
            content: "";
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 0;
        }
        `}
`;

const Arrow = styled.button`
    background: white;
    border: 0;
    border-radius: 100%;
    cursor: pointer;
    display: none;
    line-height: 2.5em;
    outline: none;
    padding: 0;
    position: absolute;
    transform: translate3d(0, -50%, 0);
    top: 50%;
    width: 2.5em;

    &:focus { outline: none; }

    ${props => props.right ? 'left: -1em;' : 'right: -1em'}
`;

const Scrollable = styled.div`
    overflow-x: auto;
    padding-bottom: 1em;
    position: relative;
    scroll-behavior: smooth;
    width: 100%;

    &.can-scroll-left { mask-image: linear-gradient(to left, transparent 0%, black 10%); }
    &.can-scroll-right { mask-image: linear-gradient(to left, black 90%, transparent); }
    &.can-scroll-left.can-scroll-right { mask-image: linear-gradient(to left, transparent 0%, black 10%, black 90%, transparent); }

    &.can-scroll-left + .arrows > ${Arrow}:last-child { display: block; }
    &.can-scroll-right + .arrows > ${Arrow}:first-child { display: block; }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar { display: none; }
    }
`;

class SeatsSelectionAuditoriumWithArrows extends React.Component {
  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);
    this.scrollRight = this.scrollRight.bind(this);
    this.scrollLeft = this.scrollLeft.bind(this);

    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.ref) {
      window.addEventListener('resize', this.onResize);
      this.ref.current.addEventListener('scroll', this.onResize);
      this.onResize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const s = this.ref.current;
    
    if (!s) return;

    const canScrollLeft = Math.ceil(s.clientWidth + s.scrollLeft) < s.scrollWidth;
    const canScrollRight = s.scrollLeft > 0;

    if (canScrollLeft) {
      s.classList.add('can-scroll-left');
    } else {
      s.classList.remove('can-scroll-left');
    }

    if (canScrollRight) {
      s.classList.add('can-scroll-right');
    } else {
      s.classList.remove('can-scroll-right');
    }
  }

  scrollRight() {
    this.ref.current.scrollLeft -= this.getScrollAmount();
  }

  scrollLeft() {
    this.ref.current.scrollLeft += this.getScrollAmount();
  }

  getScrollAmount() {
    return this.ref.current.clientWidth * 0.2;
  }

  render() {
    return (
        <div className="c-seats">
          <Auditorium className="c-seats__container" screenImage={this.props.screenImage !== null}>
            <SeatsScreen />
            <div style={{zIndex:2}}>
              <Scrollable innerRef={this.ref}>
                {this.props.children}
              </Scrollable>
              <div className="arrows">
                <Arrow right onClick={this.scrollRight}><i className="fal fa-arrow-left"></i></Arrow>
                <Arrow left onClick={this.scrollLeft}><i className="fal fa-arrow-right"></i></Arrow>
              </div>
            </div>
          </Auditorium>
        </div>
    );
  }
}

const mapStateToProps = state => ({
  screenImage: state.checkoutData.data.screen_override || null,
});

export default connect(
  mapStateToProps
)(SeatsSelectionAuditoriumWithArrows);